import styled from 'styled-components'

export const Divider = styled.hr`
  height: 1px;
  border: none;
  color: ${({ theme }) => theme.palette.giphyLightestGrey};
  background-color: ${({ theme }) => theme.palette.giphyLightestGrey};
  margin: 100px 0 90px 0;
`
